import React from "react";
import "./loader.css";
import GOLD from "./Gold.png";

const Loader = () => {
  return (
    <div className="loader-container">
      <div className="coin-spinner">
        <img src={GOLD} alt="Loading..." className="coin" />
      </div>
      <p className="loading-text">Loading, please wait...</p>
    </div>
  );
};

export default Loader;
